export default class UserScopedPaths {
  public static tenants() {
    return '/tenants'
  }
}
